import { logWrapper } from '../utils';

export default {
  companySubsidiariesModel: [
    'runtimeConstant',
    function (runtimeConstant) {
      function CompanySubsidiaries(data) {
        if (!data) {
          this.id = data.Id;
        }

        this.id = data.Id;
        this.name = data.Name;
        this.cnpj = data.Cnpj;
        this.uf = data.Uf;
        this.idCompany = data.IdCompany;
        this.idFolder = data.IdFolder;
      }

      function title() {
        return this.name;
      }

      function run() {
        try {
          CompanySubsidiaries.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
          };

          return CompanySubsidiaries;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
